import axios from 'axios';
import { authHeader, loggedIn } from '@/_legacy/services/authentication';
import { getLocale } from '@/ui/i18n/i18n';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

instance.interceptors.request.use(
  request => {
    if (loggedIn()) {
      request.headers = {
        ...request.headers,
        ...{ 'Accept-Language': getLocale() },
        ...authHeader(),
      };
    }
    return request;
  },
);

export default instance;
